'use strict';

var pseudoStyle = require('./pseudo-style');
module.exports = pseudoStyle('hover')({
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  boxShadow: 'shadows'
});


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/hover.js
// module id = 380
// module chunks = 168707334958949